import {Injectable} from "@angular/core";
import { environment } from "@sharedenvironment";
import {NeqHttpClient} from "@sharedrest/http-client.config";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class DmsRestService {

    constructor(private neqHttpClient: NeqHttpClient) {
    }

    /**
     * Get document from DMS by ID
     * Response code 200 - bulletin found
     * Response code 4O4 - bulletin not found
     * Response code 500 - Error
     * HTTP GET /document/{id}
     * Java method: com.neovia.services.dms.controller.GedController.downloadDocument()
     */
    getDocument(documentId: string): Observable<any> {
        return this.neqHttpClient.request({
            method: 'GET',
            url: DmsRestService.getApiUrl(`document/download?id=${documentId}`),
            responseType: 'blob'
        });
    }

    private static getApiUrl(apiRoute: string): string {
        return environment.dms.baseUrl + apiRoute;
    }
}
